<template>
  <div
    class="wtv-form-control"
    :class="{ 'wtv-form-control-text': isTextarea }"
  >
    <div
      class="wtv-form-label"
      v-show="value || error"
      :class="{ 'wtv-red': error }"
    >
      {{ error || label }}
    </div>
    <input
      v-if="output !== undefined"
      class="wtv-form-input"
      @input="onInput"
      @focus="onFocus"
      :value="output"
      :placeholder="label"
    />
    <textarea
      style="height: 111px"
      v-if="isTextarea"
      class="wtv-form-input"
      @focus="onFocus"
      @input="onInput"
      :value="value"
      :placeholder="label"
      :hidden="output !== undefined"></textarea>
    <input
      v-else
      class="wtv-form-input"
      @focus="onFocus"
      @input="onInput"
      :value="value"
      :placeholder="label"
      :hidden="output !== undefined"
    />
    <div
      v-if="required && !value"
      class="wtv-form-input-requirator wtv-icon"
      :class="{ 'wtv-red': error }"
    ></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    value: String,
    output: String,
    error: String,
    label: String,
    required: Boolean,
    onInput: Function,
    isTextarea: Boolean,
  },

  setup() {
    // const onClick = (e: Event) => {
    //   e.preventDefault();
    //   e.stopPropagation();
    // };
    const onFocus = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      setTimeout(() => {
        ((e.target as HTMLElement).parentElement as HTMLElement).scrollIntoView({ behavior: 'smooth' });
      }, 666);
    };
    return {
      // onClick,
      onFocus,
    };
  },
});
</script>

<style scoped>
.wtv-form-control-text {
  flex: 4 2 100%;
  max-width: unset;
}
.wtv-form-input-requirator {
  position: absolute;
  right: 9px;
  top: 9px;
  padding: 16px 10px 14px;
  cursor: pointer;
  pointer-events: none;
  transition: 0.3s;
}
.wtv-form-input-requirator:before {
  content: '\f069';
  color: var(--color-text-5);
  font-size: 12px;
}
.wtv-red,
.wtv-red:before {
  color: var(--color-second);
}
.wtv-form-input::placeholder {
  color: var(--color-text);
  font-weight: 600;
  opacity: 0.75;
}
.wtv-form-input:focus::placeholder {
  color: var(--color-alt);
}
</style>
